// extracted by mini-css-extract-plugin
export default {"itemsList":"filterList_itemsList__8sO69","item":"filterList_item__j2KqT","currentItem":"filterList_currentItem__Z59tx"};